import styled from 'styled-components';
import { Button, Col, Form, Layout, Row, Table } from 'antd';
import bgTruck from '../../assets/images/bgTruck.svg';

export const Wrapper = styled(Layout)`
  min-height: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #f4f6f5;

  > .ant-spin-nested-loading,
  > .ant-spin-nested-loading > .ant-spin-container {
    width: 100%;
  }
  .ant-pagination-item-active {
    border-radius: 0;
  }
  .ant-pagination-item-link {
    border-radius: 0;
  }
  .ant-pagination-item-link:hover {
    border-radius: 0;
    border-color: #24a95d;
  }

  .ant-pagination-item-active {
    border-color: #24a95d;
    border-radius: 0;
  }
  .ant-pagination-item a:hover {
    border-color: #24a95d;
    color: #24a95d;
    border-radius: 0;
  }
  .ant-pagination-item {
    color: #24a95d;
    border-radius: 0;
  }
  .ant-pagination-item:hover {
    border-color: #24a95d;
    color: #24a95d;
    border-radius: 0;
  }
  .ant-pagination-item-active a {
    color: #24a95d;
    border-radius: 0;
  }
  .ant-input {
    background: #f2f2f2;
    border-radius: 0;
  }
  .ant-tabs {
    position: relative;
  }
  .ant-tabs-nav-list {
    margin-left: 15px;
  }
  .ant-tabs-nav {
    margin: 0;
    .ant-tabs-tab {
      background: #fff;
      font-size: 14px;
      line-height: 22px;
    }
    .ant-tabs-tab-active {
      background: #24a95d;
      font-size: 14px;
      line-height: 22px;
      .ant-tabs-tab-btn {
        color: #fff;
      }
    }
  }
  th.ant-table-cell {
    background: #fff;
    border-bottom: 2px solid #cacaca;
    text-align: center;
  }
  tr.ant-table-expanded-row td {
    background: #f2f2f2;
  }

  div::-webkit-scrollbar {
    width: 8px;
  }
  div::-webkit-scrollbar-track {
    background: #f4f4f4;
    margin: 145px 0 5px 0;
    border-radius: 20px;
  }
  div::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 20px;
  }
  .ant-tabs.ant-tabs-top.ant-tabs-card {
    top: -28px;
  }
  .ant-tabs-tabpane.ant-tabs-tabpane-active {
    height: 565px;
    overflow: auto;
    padding: 28px 20px;
  }
  .ant-tabs-nav-list {
    margin-left: 15px;
  }
  .ant-tabs-nav {
    margin: 0;
    .ant-tabs-tab {
      background: #fff;
      font-size: 14px;
      line-height: 22px;
    }
    .ant-tabs-tab-active {
      background: #24a95d;
      font-size: 14px;
      line-height: 22px;
      .ant-tabs-tab-btn {
        color: #fff;
      }
    }
  }

  @media (max-width: 1100px) {
    padding: 24px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    background: #f3f5f4;

    .ant-spin-text {
      font-size: 12px;
    }
  }
`;

export const Card = styled.div`
  width: 100%;
  padding: 25px;
  background: #fff;
  border: 1px solid #edf0ee;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 18px 16px;
    border-radius: 16px;
    box-shadow: 0 4px 18px rgba(13, 54, 74, 0.06);
  }
`;

export const BannerArea = styled.div`
  margin-bottom: 18px;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 900px) {
    align-items: stretch;
    flex-direction: column;
    gap: 18px;
  }
`;

export const SearchField = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  min-width: 0;

  @media (max-width: 1100px) {
    gap: 20px;
  }

  @media (max-width: 600px) {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
`;

export const CpfFormItem = styled(Form.Item)`
  width: 200px;
  margin: 0;

  .ant-input {
    width: 100%;
    min-height: 44px;
    padding: 10px 12px;
    font-size: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
  }

  @media (max-width: 600px) {
    width: 100%;

    .ant-input {
      min-height: 50px;
      border-radius: 12px;
    }
  }
`;

export const SubmitFormItem = styled(Form.Item)`
  margin: 0;
  text-align: right;
`;

export const PrimaryButton = styled(Button)`
  width: 170px;
  height: 50px;
  border: none;
  border-radius: 4px;
  background: #24a95d;
  font-weight: 700;

  &:hover,
  &:focus {
    background: #1e914f !important;
  }

  @media (max-width: 900px) {
    width: 100%;
  }

  @media (max-width: 600px) {
    height: 52px;
    border-radius: 12px;
    font-size: 16px;
  }
`;

export const ResultsGrid = styled.section`
  display: grid;
  grid-template-columns: ${({ $singleColumn }) =>
    $singleColumn ? 'minmax(0, 1fr)' : 'repeat(2, minmax(0, 1fr))'};
  gap: 32px;
  margin-top: 16px;

  @media (max-width: 1050px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const EmptyCard = styled(Card)`
  display: flex;
  align-items: center;
  min-height: 150px;
  margin-top: 32px;

  @media (max-width: 768px) {
    min-height: 180px;
    margin-top: 16px;
    text-align: center;
  }
`;

export const FooterArea = styled.footer`
  margin-top: 24px;

  @media (max-width: 768px) {
    margin-top: 16px;
    padding-bottom: max(4px, env(safe-area-inset-bottom));
  }
`;

export const BannerCard = styled(Card)`
  position: relative;
  min-height: 150px;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: auto;
    padding: 20px 16px;
    background: linear-gradient(135deg, #ffffff 0%, #f0faf4 100%);
  }
`;

export const BannerContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  width: 100%;

  @media (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }
`;

export const BannerCopy = styled.div`
  width: min(720px, 72%);

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const BannerButton = styled(PrimaryButton)`
  width: 136px;
  height: 40px;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    height: 46px;
  }
`;

export const DivPositionRelative = styled.div`
  position: relative;
  bottom: 0;
`;

export const StartMessageH1 = styled.h1`
  font-weight: 700;
  font-size: ${({ fontSize }) => fontSize || '20px'};
  line-height: 1.25;
  color: #2d3a40;
  margin: 0 0 8px;

  @media (max-width: 768px) {
    font-size: ${({ fontSize }) => (fontSize ? '22px' : '18px')};
  }
`;

export const StartMessageP = styled.p`
  font-weight: 400;
  font-size: ${({ fontSize }) => fontSize || '16px'};
  color: ${({ color }) => color || '#707070'};
  text-align: ${({ textAlign }) => textAlign || 'center'};
  line-height: 1.5;
  margin: 0;
`;

export const DivDisplayFlex = styled.div`
  display: flex;
  align-items: ${({ alignItems }) => alignItems || 'center'};
  position: relative;
  justify-content: center;
  flex-direction: column;
  width: ${({ width }) => width || '100%'};
`;

export const DivBackground = styled.div`
  display: flex;
  position: absolute;
  background-image: url(${bgTruck});
  height: 100%;
  width: 200%;
  background-size: auto auto;
  background-repeat: no-repeat;
  background-position: left center;
  opacity: 0.72;
  pointer-events: none;

  @media (max-width: 768px) {
    right: -60px;
    width: 260px;
    opacity: 0.12;
  }
`;

export const TextFooter = styled.p`
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  color: #707070;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 1.45;
  }
`;

export const Text = styled.p`
  white-space: nowrap;
  margin: 0;
  color: #707070;
  font-size: 16px;
  font-weight: 500;
  > span {
    font-weight: bold;
  }

  @media (max-width: 600px) {
    white-space: normal;
    font-size: 14px;
  }
`;
export const NumberCol = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 30px;
  color: #24a95d;
`;
export const TimeCol = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #707070;
`;
export const TextCol = styled.p`
  margin: 0;
  color: #707070;
`;

export const Dropdown = styled.div`
  #dropdown {
    border: 1px solid black;
    width: 100%;
    height: 200px;
    opacity: 0;
    display: none;
    animation: dropdown 1s ease-in-out;
  }
  #dropdown-active {
    border: 1px solid black;
    width: 100%;
    height: 0;
    opacity: 0;
    display: block;
  }
  @keyframes dropdown {
    to {
      height: 200px;
      opacity: 1;
    }
  }
`;
export const RowTitle = styled(Col)`
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 22px;
  color: #001f2a;
  padding: 15px;
  border-bottom: 2px solid #cacaca;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #707070;
  font-weight: normal;
`;

export const StyledColTitle = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #001f2a;
`;
export const RowData = styled(Row)`
  :nth-child(even) {
    background: #f2f2f2;
  }
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: #001f2a;
  padding: 15px;
`;
export const RowsForColumn = styled.div`
  :nth-child(odd) {
    background: #f2f2f2;
  }
  #dropdown {
    max-height: 0;
    overflow: hidden;
    transition: max-height 300ms ease-in-out;
    background-color: #f2f2f2;
  }
  #dropdown.active {
    max-height: 70px;
    height: 70px;
    transition: max-height 300ms ease-in-out;
  }
  .dropImg {
    transform: rotate(0deg);
    transition: transform 300ms ease-in-out;
    cursor: pointer;
  }
  .dropImg.active {
    transform: rotate(180deg);
    transition: transform 300ms ease-in-out;
    cursor: pointer;
  }
`;
export const RowDrop = styled(Row)`
  display: flex;
  align-items: center;
  justify-content: space-around;

  height: 70px;
  background-color: #f2f2f2;
  border-radius: 2px;
`;
export const ColDrop = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;

  > label {
    font-weight: bold;
    font-size: 12px;
    line-height: 22px;
    text-align: center;
    color: #001f2a;
  }
  > p {
    font-size: 12px;
    line-height: 22px;

    text-align: center;

    color: #707070;
  }
`;

export const WrapperLeft = styled.div`
  display: flex;
  justify-content: ${({ statusId }) =>
    statusId !== 3 ? 'flex-start' : 'flex-end'};
`;

export const Title = styled.h1`
  text-align: ${({ statusLabel }) => (statusLabel !== 3 ? 'center' : 'start')};
  font-size: 18px;
  font-weight: bold;
  color: #707070;
  border-bottom: 2px solid #bdbdbd;
  height: 55px;
  margin: 0 0 8px;

  @media (max-width: 768px) {
    height: auto;
    min-height: 44px;
    margin-bottom: 4px;
    padding-bottom: 12px;
    text-align: left;
  }
`;

export const TitleTable = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #707070;
  width: ${({ statusId }) => (statusId !== 3 ? '50%' : '23%')};
`;

export const TitleData = styled.p`
  color: #707070;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.35;
  margin: 0 0 5px;
`;

export const DiplayFlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;
export const LabelData = styled.div`
  color: ${({ statusLabel }) =>
    statusLabel === 'Atualizado'
      ? '#24A95D'
      : statusLabel === 'Desatualizado'
      ? '#D42929'
      : '#828282'};
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: ${({ statusId }) => (statusId !== 3 ? 'start' : 'center')};
  line-height: 1.45;
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const LabelImage = styled.div`
  display: flex;
  align-items: center;
  text-align: ${({ statusId }) => (statusId !== 3 ? 'center' : 'flex-start')};
  font-weight: bold;
  img {
    margin-right: 5px;
    width: 17px;
    height: 17px;
  }
  span {
    font-weight: normal;
  }

  @media (max-width: 768px) {
    align-items: flex-start;
    text-align: left;
  }
`;
export const ColLabelData = styled(Col)`
  display: flex;
  font-size: 14px;
  margin-bottom: 12px;

  margin-top: 15px;
  max-width: ${({ statusid }) => (statusid !== 3 ? '50%' : '23%')};
  width: ${({ statusid }) => (statusid !== 3 ? '50%' : '23%')};
  justify-content: ${({ statusid }) =>
    statusid !== 3 ? 'flex-start' : 'center'};
  flex-direction: column;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    margin: 0;
    padding: 14px 0;
    border-bottom: 1px solid #edf0ee;
    justify-content: flex-start;

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }
`;

export const ColLabelDataRigth = styled(ColLabelData)`
  max-width: ${({ statusid }) => (statusid !== 3 ? '33%' : '23%')};
  width: ${({ statusid }) => (statusid !== 3 ? '33%' : '23%')};

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const Fundo = styled.div`
  padding: ${({ active }) => (active ? '32px' : '0')};
  border-radius: 4px;
  background: #fff;
  min-width: 120px;
  height: ${({ active }) => (active ? '345px' : '0')};
  transition: all 0.3s ease;
  overflow-y: auto;
  border: 1px solid #edf0ee;
  box-shadow: 0 3px 14px rgba(13, 54, 74, 0.04);

  @media (max-width: 768px) {
    height: auto;
    min-height: 0;
    padding: ${({ active }) => (active ? '20px 16px' : '0')};
    border-radius: 16px;
    overflow: visible;
    box-shadow: 0 4px 18px rgba(13, 54, 74, 0.06);

    > .ant-row {
      display: block;
    }
  }
`;

export const TableStyled = styled(Table)`
  th {
    background: #f2f2f2 !important;
    font-weight: 500;
    text-align: left !important;
  }
`;

export const HyperLink = styled.a`
  color: #24a95d;
  background-color: transparent;
  text-decoration: none;

  :hover {
    color: #24a95d;
    background-color: transparent;
    text-decoration: underline;
  }
`;
